import { IAIWorkspace, IAIWorkspaceRequest } from "@entities/aiWorkspace";
import { ScriptVetDetail } from "./ScriptVetDetail";
import { ScriptVetList } from "./ScriptVetList";

type ScriptVetTabProps = {
  workspace: IAIWorkspace;
  requests: IAIWorkspaceRequest[];
  requestId: string;
  onOpenRequest: (requestId: string, type: string) => void;
  onCloseRequest: () => void;
};

export function ScriptVetTab({
  workspace,
  requests,
  requestId,
  onOpenRequest,
  onCloseRequest,
}: ScriptVetTabProps) {
  return (
    <div>
      {requestId ? (
        <ScriptVetDetail requestId={requestId} onBack={onCloseRequest} />
      ) : (
        <ScriptVetList
          workspace={workspace}
          requests={requests}
          onOpenRequest={onOpenRequest}
        />
      )}
    </div>
  );
}
